module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAsklEQVQ4T62TTQpCIRRGvztwZDRu5ooiCpzk5BotxJ14oW1E0BaaNGrQRiqEHlj5UiNHopzj/ZOQLWaeA1iJyAbAPb8r7Sk/dM5NlVJHIjrFGLkmeIGTqEfwAfcIinAm2BPReSyFUTgJrLUTrfUBwEVE1u81+ArnglIEVTgJmHkG4ApgKyK7oUNVeAg9vWyM8SGEWxP8c87PfvdXu3VQ/jdhrS8WC+a9XwBYxhh97VMkwQO/6VcQn1V0BgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personal/right.png
// module id = nW6m
// module chunks = 0